__turbopack_context__.v({
  "benefit": "CnoPro-module__mu6l-a__benefit",
  "cnoProInfoDescription": "CnoPro-module__mu6l-a__cnoProInfoDescription",
  "description": "CnoPro-module__mu6l-a__description",
});
